import {
  GET_CONVERSATIONS_RECENT_REQUEST,
  CREATE_CONVERSATION_REQUEST,
  CHECK_DATA_CONVERSATION_REQUEST,
} from '../constants/action-types';

export const requestRecentConversations = () => ({
  type: GET_CONVERSATIONS_RECENT_REQUEST,
});

export const requestCreateConversation = data => ({
  type: CREATE_CONVERSATION_REQUEST,
  data,
});

export const requestCheckDataConversation = data => ({
  type: CHECK_DATA_CONVERSATION_REQUEST,
  data,
});
